import styled from 'styled-components';

export const ArticleSection = styled.div`
  .accordion-header-expanded {
    color: #314259;
    font-weight: 700;
  }
`;

export const ArticleWrapper = styled.div`
  h2 {
    font-size: 32px;
    font-weight: 700;
    margin: 48px 0 16px;
  }
  p {
    font-size: 20px;
    color: #9092a3;
    margin-bottom: 40px;
    font-weight: 400;
  }

  a {
    color: #1572ed;
  }
  a:hover {
    text-decoration: underline;
  }

  li {
    font-size: 20px;
    color: #9092a3;
    margin-bottom: 16px;
  }
  ol {
    list-style-type: decimal;
    padding-left: 24px;
  }

  ul {
    list-style-type: disc;
    padding-left: 24px;
  }

  @media (max-width: 767px) {
    h2 {
      font-size: 18px;
      margin: 16px 0 8px;
    }
    p {
      font-size: 16px;
      margin-bottom: 28px;
    }
    li {
      font-size: 16px;
    }
    ol,
    ul {
      padding-left: 16px;
    }
  }
`;

export const ToCContainer = styled.div`
  .tocHead {
    border-bottom: 0.5px solid #e5e5e9;
  }
  .tocItem {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
export const CardWrap = styled.div`
  a:hover {
    text-decoration: underline;
  }
`;
export const TopCTABannerITR = styled.div`
  .banner_outer_outer_container {
    .anchor-tag {
      text-decoration: none;
      color: black;
      outline: none;
      border: none;
      background: none;
      cursor: pointer;
    }
    .banner_outer_container {
      background-color: #0065e3;
      height: 200px;
      font-family: Gilroy;
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;

      .percentage-num {
        font-size: 36px;
      }

      .right-subsection-small {
        display: none;
      }

      .small-banner-image {
        display: none;
      }

      .heading,
      .small-heading {
        font-weight: 700;
        font-size: 41px;
        line-height: 101%;
        color: white;
        padding-bottom: 18px;
      }

      .small-heading {
        display: none;
      }

      .subheading {
        font-weight: 500;
        font-size: 25px;
        line-height: 23px;
        color: white;
      }

      .banner-image {
        height: 200px;
        width: auto;
      }
      .mid-section {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 57px;
      }
      .banner-right {
        background-image: url('https://assets.clear.in/cleartax/images/1757319582_group18142243611.png');
        background-position: left;
        background-repeat: no-repeat;
        font-weight: 700;
        font-size: 28px;
        line-height: 21px;
        white-space: nowrap;
        width: 384px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        justify-content: center;
      }
      .right-subsection,
      .right-subsection-small {
        padding-right: 40px;
        text-align: center;
      }
      .banner-button {
        text-decoration: none;
        font-family: Gilroy;
        font-weight: 700;
        margin-top: 10px;
        margin-right: 5px;
        line-height: 132%;
        border-radius: 4px;
        white-space: nowrap;
        padding: 10px 55px;
        font-size: 21px;
        color: #ffffff;
        background: #1572ed;
      }
      @media screen and (min-width: 1024px) and (max-width: 1439px) {
        .small-heading {
          font-size: 40px;
          display: block;
        }
        .heading {
          display: none;
        }
        .subheading {
          font-size: 20px;
          line-height: 15px;
        }
        .mid-section {
          padding-left: 30px;
        }
        .banner-right {
          background-image: url('https://assets.clear.in/cleartax/images/1757318991_group1814224362.png');
          background-position: left;
          background-repeat: no-repeat;
          width: 382px;
        }
        .right-subsection {
          font-size: 22px;
        }
        .banner-button {
          font-size: 18px;
        }
        .right-subsection {
          padding-right: 9px;
          font-size: 20px;
        }
        .banner-image {
          width: 332px;
        }
        .percentage-num {
          font-size: 36px;
        }
      }
      @media screen and (min-width: 768px) and (max-width: 1023px) {
        .small-heading {
          font-size: 31px;
          display: block;
        }
        .heading {
          display: none;
        }
        .subheading {
          font-size: 16px;
          line-height: 17px;
        }
        .mid-section {
          padding-left: 30px;
        }
        .banner-right {
          background-image: url('https://assets.clear.in/cleartax/images/1757321632_frame21472246052.png');
          background-position: left;
          background-repeat: no-repeat;
          width: 244px;
        }

        .right-subsection {
          font-size: 18px;
        }
        .banner-button {
          font-size: 18px;
        }
        .right-subsection {
          padding-right: 6px;
        }
        .banner-image {
          width: 222px;
        }
        .percentage-num {
          font-size: 24px;
        }
      }
      @media screen and (max-width: 767px) {
        .banner-image {
          display: none;
        }
        position: relative;
        .banner-right {
          background-image: url('https://assets.clear.in/cleartax/images/1757319102_itrfilinglivestaticbanner1440x2005.png');
          background-position: left;
          background-repeat: no-repeat;
          width: 209px;
        }
        .small-banner-image {
          display: block;
          height: 100px;
          width: 175px;
          position: absolute;
          top: 0;
          left: 0;
        }
        .small-heading {
          font-size: 20px;
          display: block;
          padding-left: 25px;
          padding-top: 110px;
        }
        .heading {
          display: none;
        }
        .subheading {
          font-size: 11px;
          line-height: 15px;
          padding-left: 25px;
          padding-bottom: 25px;
        }
        .mid-section {
          padding-left: 0px;
        }
        .right-subsection-small {
          font-size: 18px;
          padding-right: 20px;
          display: block;
        }
        .banner-button {
          font-size: 18px;
          padding: 8px 23px;
        }
        .right-subsection {
          display: none;
        }
        .percentage-num {
          font-size: 25px;
        }
        .banner-button {
          font-size: 10px;
        }
      }
    }
  }
`;
